import { createErrorMatcher } from '@shared/lib/http-error';

const isExpiredCodeError = createErrorMatcher('ExpiredCodeException');
const isCodeMismatchError = createErrorMatcher('CodeMismatchException');
const isNotAuthorizedError = createErrorMatcher('NotAuthorizedException');

export { isExpiredCodeError, isCodeMismatchError, isNotAuthorizedError };
